export default {
  required: "{{label}} is required.",
  dropRequire: "{{label}} is required.",
  compare: "{{label}} doesn't match",
  matches: "The {{label}} field does not match the {{label}} field.",
  email: "Please enter a valid {{label}}.",
  min: "The {{label}} field must be at least {{length}} characters in length.",
  max: "The {{label}} field must not exceed {{length}} characters in length.",
  maxNewLine:
    "Got an address with {{length}}+ characters? Use the next line, too!",
  maxCounter: "Maximum {{length}} characters ({{extra}}).",
  maxCounterNewLine:
    "Got an address with {{length}}+ characters? Use the next line, too! ({{extra}}).",
  exact: "The {{label}} field must be exactly {{length}} characters in length.",
  greaterThan:
    "The {{label}} field must contain a number greater than {{label}}.",
  lessThan: "The {{label}} field must contain a number less than {{label}}.",
  alpha: "The {{label}} field must only contain alphabetical characters.",
  alphaNumeric:
    "The {{label}} field must only contain alpha-numeric characters.",
  alphaDash:
    "The {{label}} field must only contain alpha-numeric characters, underscores, and dashes.",
  numeric: "The {{label}} field must contain only numbers.",
  integer: "The {{label}} field must contain an integer.",
  decimal: "The {{label}} field must contain a decimal number.",
  phone: "Please enter a valid {{label}}.",
  phoneMask: "Please enter a valid {{label}}.",
  zipcode: "Please enter a valid {{label}}.",
  poBox: "Shipping to PO Box, mailbox, and APO/FPO addresses are not supported",
  reCaptcha: "Verification failed. Please try again."
};
